<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-h-0">
  <!-- Content -->
  <div class="flex flex-col flex-auto min-h-0">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
